// extracted by mini-css-extract-plugin
export default {"container":"Seguranca_container__ilGTh","wrapper":"Seguranca_wrapper__UtWT1"};